<script setup lang="ts">
import CreatePolicyDialog from '@/components/asicw/policies/create-dialog/CreatePolicyDialog.vue'
import PolicyGroupsTable from '@/components/rc/tables/PolicyGroupsTable.vue'
import { Plus } from '@element-plus/icons-vue'
import { computed, ref } from 'vue'

const props = defineProps<{
  customerId: number
}>()

const policyGroupCreationDialogVisible = ref<boolean>(false)

const customerIdNumber = computed(() => props.customerId)
</script>

<template>
  <div class="flex flex-col gap-8">
    <PolicyGroupsTable v-if="customerIdNumber" :customer-id="customerIdNumber">
      <template #controls>
        <el-button :icon="Plus" type="primary" @click="policyGroupCreationDialogVisible = true"
          >Create new group</el-button
        >
      </template>
    </PolicyGroupsTable>
    <CreatePolicyDialog v-model="policyGroupCreationDialogVisible" />
  </div>
</template>
